import {isAgentUser,canViewAgentDashboard,canViewAgentWallet} from '../../auth/loginDestination';
import {AGENT_PIN_ENABLED} from '../../config/features';

// Role selects the menu family; permissions only filter entries within it.
export const usesAgentMenu=user=>user?.isAdmin!==true&&isAgentUser(user);
const link=(id,label,path,icon,extra={})=>({id,label,path,icon,...extra});
export function getAgentMenu(user,screens=[],brand={}){
 if(!usesAgentMenu(user))return [];
 const has=permission=>screens.includes(permission);
 const settlement=[
  has('상세정보')&&link('approval','승인내역','/payDetailList','document'),
  has('가맹점 정산내역')&&link('merchantSettlement','가맹점 내역','/settlements','document'),
  has('에이전트 정산내역')&&link('agentSettlement','에이전트 내역','/settlementsAgent','document'),
 ].filter(Boolean);
 return [
  canViewAgentDashboard(user)&&link('dashboard','내 수익','/agentDashboard','dashboard',{shortcut:true}),
  has('거래내역')&&link('transactions','거래조회','/paylist','transactions',{shortcut:true,desktopLabel:'거래'}),
  {id:'settlement',label:'정산',icon:'settlement',children:settlement},
  has('가맹점')&&link('merchants','가맹점 관리','/submerchants','network'),
  has('통합에이전트')&&link('agents','에이전트','/integrateAgent','agents'),
  canViewAgentWallet(user,screens)&&link('wallet','지갑','/agentWallet','wallet',{shortcut:true}),
  has('수기결제')&&link('manual','수기 신청','/sugiManage','manual'),
  // Preserve the existing surface-specific destinations during this structural change.
  has('수기결제승인내역')&&link('manualHistory','수기 승인/취소','/sugiListManage','document',{mobilePath:'/submerchants'}),
  AGENT_PIN_ENABLED&&link('pin','PIN 관리','/agentPin','pin',{account:true}),
 ].filter(Boolean);
}
export function agentMenuForSurface(items,surface){
 return items.filter(item=>!item.surfaces||item.surfaces.includes(surface)).map(item=>({...item,...(item.children?{children:agentMenuForSurface(item.children,surface)}:{})}));
}
